import { useState } from 'react'
import { Modal } from 'react-bootstrap'

import './CModal.scss'
import s from './Modal.module.scss'

import { Spinner } from '../Spinner/Spinner'

import { CloseIcon } from 'assets/icons/CloseIcon'

import { Card } from 'components/UI/Card/Card'

interface Props {
  loading?: boolean
  children: React.ReactNode | React.ReactNode[]
  onHide: () => void
  variant: 'secondary' | 'primary'
  centered?: boolean
  style?: React.CSSProperties
  className?: string
}

export const CModal = (props: Props) => {
  const { loading, children, onHide, variant, centered, style, className } = props

  const [show, setShow] = useState(true)

  if (loading)
    return (
      <Modal show={show} centered={centered || true} style={style} className={className}>
        <Spinner />
      </Modal>
    )

  return (
    <Modal
      show={show}
      centered={centered ?? true}
      backdrop
      style={style}
      onHide={() => {
        onHide()
        setShow(false)
      }}
    >
      <div className={`${s.modalWrapper} ${className}`}>
        <button
          className={s.closeButton}
          onClick={() => {
            onHide()
            setShow(false)
          }}
        >
          <CloseIcon className={s.closeIcon} />
        </button>
        <Card variant={variant}>{children}</Card>
      </div>
    </Modal>
  )
}

interface InfoProps {
  children: React.ReactNode | React.ReactNode[]
  style?: React.CSSProperties
  className?: string
}

const Info = ({ children, style, className }: InfoProps) => {
  return (
    <Card.Info style={{ ...style }} className={`${s.modalInfo} ${className}`}>
      {children}
    </Card.Info>
  )
}
CModal.Info = Info

interface ImageProps {
  height: number
  children: React.ReactNode | React.ReactNode[]
}

const Image = ({ children, height }: ImageProps) => {
  return <Card.Image height={height}>{children}</Card.Image>
}
CModal.Image = Image

interface TitleProps {
  children: React.ReactNode | React.ReactNode[]
}

const Title = ({ children }: TitleProps) => {
  return <h1 className={s.title}>{children}</h1>
}

CModal.Title = Title
